import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M20 10c0 5.5-4.5 10-10 10S0 15.5 0 10 4.5 0 10 0s10 4.5 10 10z',
    'M15.25 5.833l-7.083 7.083L5.25 9.999l-.583.583 3.5 3.5 7.667-7.667z',
  ],
  height: 20,
  width: 20,
});
